import type {
  DashboardAnalytics,
  DashboardFilters,
} from "@home-finance-manager/shared/types/dashboard"
import { BaseSDK } from "./base-sdk"

export class DashboardSDK extends BaseSDK {
  /**
   * Get dashboard analytics
   * @param filters - Optional filters for analytics
   * @returns Dashboard analytics data
   * @throws {AuthError} If authentication/authorization fails (401, 403)
   * @throws {ClientError} If request is invalid (400-499, excluding 401, 403)
   * @throws {ServerError} If server error occurs (500-599)
   * @throws {NetworkError} If network request fails
   */
  async getAnalytics(filters?: DashboardFilters): Promise<DashboardAnalytics> {
    const params = new URLSearchParams()

    if (filters?.categoryIds && filters.categoryIds.length > 0) {
      filters.categoryIds.forEach((id) => params.append("categoryIds[]", String(id)))
    }

    if (filters?.partnerIds && filters.partnerIds.length > 0) {
      filters.partnerIds.forEach((id) => params.append("partnerIds[]", String(id)))
    }

    if (filters?.search) {
      params.append("search", filters.search)
    }

    if (filters?.startDate) {
      params.append("startDate", filters.startDate)
    }

    if (filters?.endDate) {
      params.append("endDate", filters.endDate)
    }

    if (filters?.includeVirtualExpenses === true) {
      params.append("includeVirtualExpenses", "true")
    }

    const queryString = params.toString()
    const url = `${this.baseUrl}/dashboard/analytics${queryString ? `?${queryString}` : ""}`

    const response = await this.fetchWithErrorHandling<{ data: DashboardAnalytics }>(url, {
      headers: this.getAuthHeaders(),
    })

    return this.extractData<DashboardAnalytics>(response)
  }
}
